var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"publicHall"},[_c('NavBar'),_c('header',{staticClass:"title"},[_vm._v("发布的展馆")]),_c('pavilion-list',{on:{"clickPavilion":_vm.BrowsePavilion}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }